module.exports = __webpack_public_path__ + "media/src/images/dandori/dandori-a7a643588d945c6a61d623832d9a923d.png";